module.exports = __webpack_public_path__ + "img/en.47960282.png";